// ================= Accordion Section =================
(() => {
  document.addEventListener("DOMContentLoaded", function () {
    const triggers = document.querySelectorAll(".faq-trigger");
    let currentOpen = null;

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", function () {
        const targetId = this.getAttribute("data-target");
        const targetContent = document.getElementById(targetId);
        const iconContainer = this.querySelector(".chevron-rotate");

        // ✅ plus/minus icons support
        const plusIcon = iconContainer?.querySelector(".plus-icon");
        const minusIcon = iconContainer?.querySelector(".minus-icon");

        // --- CLOSE previously open FAQ ---
        if (currentOpen && currentOpen !== targetContent) {
          const prevBtn = currentOpen.previousElementSibling;
          const prevIcon = prevBtn.querySelector(".chevron-rotate");

          // reset previous icon rotation
          prevIcon.classList.remove("open");

          // reset plus/minus
          const prevPlus = prevIcon.querySelector(".plus-icon");
          const prevMinus = prevIcon.querySelector(".minus-icon");
          if (prevPlus && prevMinus) {
            prevPlus.classList.remove("hidden");
            prevMinus.classList.add("hidden");
          }

          // collapse previous content
          currentOpen.style.maxHeight = null;
          currentOpen.classList.remove("open");
        }

        // --- TOGGLE current clicked FAQ ---
        if (targetContent.classList.contains("open")) {
          // closing
          targetContent.style.maxHeight = null;
          targetContent.classList.remove("open");
          iconContainer.classList.remove("open");

          if (plusIcon && minusIcon) {
            plusIcon.classList.remove("hidden");
            minusIcon.classList.add("hidden");
          }

          currentOpen = null;
        } else {
          // opening
          targetContent.classList.add("open");
          targetContent.style.maxHeight = targetContent.scrollHeight + "px";
          iconContainer.classList.add("open");

          if (plusIcon && minusIcon) {
            plusIcon.classList.add("hidden");
            minusIcon.classList.remove("hidden");
          }

          currentOpen = targetContent;

          // fade animation
          const inner = targetContent.querySelector("div");
          if (inner) {
            inner.classList.add("fade-in-up");
            setTimeout(() => inner.classList.remove("fade-in-up"), 300);
          }
        }
      });
    });
  });
})();

// ================= Swiper =================
(() => {
  document.addEventListener("DOMContentLoaded", () => {
    new Swiper(".swiper", {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 4,
      coverflowEffect: {
        rotate: -10,
        stretch: -20,
        depth: 150,
        modifier: 1,
        slideShadows: false,
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: { slidesPerView: 1, effect: "slide" },
        640: { slidesPerView: 2, effect: "slide" },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
        1440: { slidesPerView: 4 },
        1920: { slidesPerView: 4 },
      },
    });
  });
})();

// ================= Tabbing Section 2 =================
(() => {
  const tabButtons2 = document.querySelectorAll(".tab-btn2");
  const desktopContents = document.querySelectorAll(".desktop-content2");

  tabButtons2.forEach((btn) => {
    btn.addEventListener("click", () => {
      const targetId = btn.getAttribute("data-target");

      tabButtons2.forEach((b) => {
        b.classList.remove("tab-active");
        b.classList.add("tab-inactive");
      });
      btn.classList.add("tab-active");
      btn.classList.remove("tab-inactive");

      desktopContents.forEach((content) => content.classList.add("hidden"));
      document.getElementById(`desktop-${targetId}`).classList.remove("hidden");
    });
  });
})();

// ================= Industry Tabs =================
(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const industryTabButtons = document.querySelectorAll(".tab-btn");
    const industryContents = document.querySelectorAll(".tab-content");

    // Default state
    if (industryTabButtons.length > 0) {
      industryTabButtons[0].classList.add("active");
      industryContents.forEach((content, i) => {
        if (i !== 0) content.classList.add("hidden");
      });
    }

    industryTabButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        const target = this.getAttribute("data-tab");

        industryTabButtons.forEach((b) => b.classList.remove("active"));
        this.classList.add("active");

        industryContents.forEach((c) => c.classList.add("hidden"));
        document.getElementById(target).classList.remove("hidden");
      });
    });
  });
})();

// ================= Counter Animation =================
(() => {
  function animateCounter(id, target) {
    const el = document.getElementById(id);
    if (!el) return;
    let current = 0;
    const increment = target / 100;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(timer);
      }
      el.textContent = Math.floor(current);
    }, 20);
  }

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounter("counter1", 15);
          animateCounter("counter2", 300);
          animateCounter("counter3", 150);
          observer.disconnect();
        }
      });
    },
    { threshold: 0.3 }
  );

  const stats = document.querySelector("#stats");
  if (stats) observer.observe(stats);
})();

// ================= Smooth Scroll =================
(() => {
  const btn = document.getElementById("scrollBtn");
  if (btn) {
    btn.addEventListener("click", function () {
      const form = document.getElementById("contactForm");
      if (form) {
        form.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  }
})();

// ================= Menu Toggle =================
function openmenu() {
  document.getElementById("close-menu").style.display = "block";
  document.getElementById("openmenu").style.display = "none";
}
function closemenu() {
  document.getElementById("close-menu").style.display = "none";
  document.getElementById("openmenu").style.display = "block";
}
// ============ captcha handling  ==============
const generateCode = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const length = 6;
  let code = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    code += characters.charAt(randomIndex);
  }

  window.captchaCode = code; // Store globally for validation
  return code;
};

// Function to create CAPTCHA image
const createCaptchaImage = () => {
  const code = generateCode();
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  canvas.width = 150;
  canvas.height = 50;

  // Set background
  context.fillStyle = "#000"; // Black background
  context.fillRect(0, 0, canvas.width, canvas.height);

  // Add text
  context.font = "30px Arial";
  context.fillStyle = "#fff"; // White text
  context.fillText(code, 20, 35);

  // Add noise lines
  for (let i = 0; i < 5; i++) {
    context.strokeStyle =
      "#" + Math.floor(Math.random() * 16777215).toString(16);
    context.beginPath();
    context.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
    context.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
    context.stroke();
  }

  // Append to container
  const captchaContainer = document.getElementById("captchaImage");
  if (captchaContainer) {
    captchaContainer.innerHTML = ""; // Clear old CAPTCHA
    captchaContainer.appendChild(canvas);
  }
};
const validateCaptcha = () => {
  const userInput = document.getElementById("captchaInput").value.trim();

  if (userInput !== window.captchaCode) {
    alert("Incorrect CAPTCHA. Please try again.");
    createCaptchaImage(); // Regenerate CAPTCHA
    return false;
  }

  return true;
};
window.onload = () => {
  createCaptchaImage();
};
window.createCaptchaImage = createCaptchaImage;
// ================= Form Handling =================
(() => {
  document.addEventListener("DOMContentLoaded", () => {
   const validateEmail = (email) => {
  const pattern = /^[^@]+@[^@]+\.[a-z]{2,}$/i;

  if (!email || !pattern.test(email)) {
    alert("Enter a valid email address.");
    return false;
  }

  // Count dots in the local part (before @)
  const localPart = email.split("@")[0];
  const dotCount = (localPart.match(/\./g) || []).length;

  if (dotCount > 2) {
    alert("Email address format is not allowed.");
    return false;
  }

  return true;
};

    const validatePhone = (phone) => {
      const cleaned = phone.replace(/\D/g, "");
      if (!cleaned || cleaned.length < 7 || cleaned.length > 15) {
        alert("Enter a valid phone number.");
        return false;
      }
      return cleaned;
    };

    document.querySelectorAll(".contactForm").forEach((form) => {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton.disabled) return;

        submitButton.disabled = true;
        submitButton.textContent = "Submitting...";

        const name = form.querySelector("#fullName").value.trim();
        const email = form.querySelector("#email").value.trim();
        const countryCodeSelect = form.querySelector("#countryCode");
        const countryCode =
          countryCodeSelect.options[countryCodeSelect.selectedIndex].dataset
            .code || "";
        const phoneRaw = form.querySelector("#phone").value.trim();
        const project = form.querySelector("#project").value.trim();

        if (!name || !email || !phoneRaw) {
          alert("Please fill all required fields.");
          submitButton.disabled = false;
          submitButton.textContent = "Submit";
          return;
        }

        if (!validateEmail(email)) {
          submitButton.disabled = false;
          submitButton.textContent = "Submit";
          return;
        }

        const cleanedPhone = validatePhone(phoneRaw);
        if (!cleanedPhone) {
          submitButton.disabled = false;
          submitButton.textContent = "Submit";
          return;
        }

        const fullPhone = countryCode + cleanedPhone;

        const formData = new FormData();
        formData.append("name", name);
        formData.append("email", email);
        formData.append("phone", fullPhone);
        formData.append("description", project);
        formData.append("source", "contact-us");

        try {
          const response = await fetch(
            `${process.env.APIURL}/blog/api/contact-us`,
            {
              method: "POST",
              body: formData,
            }
          );

          if (!response.ok) throw new Error("Submission failed");

          const result = await response.json();
          if (result?.data?.name) {
            localStorage.setItem("contact_name", result.data.name);
          }
          if (result?.data?.email) {
            localStorage.setItem("contact_email", result.data.email);
          }

          window.location.href = "/thankyou";
        } catch (err) {
          console.error(err);
          alert("An error occurred. Please try again later.");
          submitButton.disabled = false;
          submitButton.textContent = "Submit";
        }
      });
    });

    // ✅ Handle back-forward cache reload
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) window.location.reload();
    });

    // ✅ Display stored user info
    const nameElement = document.getElementById("userName");
    const emailElement = document.getElementById("userEmail");
    if (nameElement)
      nameElement.textContent =
        localStorage.getItem("contact_name") || "No Name found.";
    if (emailElement)
      emailElement.textContent =
        localStorage.getItem("contact_email") || "No Email found.";
  });
})();

// ============= according active background color =============
(() => {
  const accordions = document.querySelectorAll(".mobile_accordion");

  accordions.forEach((el) => {
    el.addEventListener("click", (e) => {
      // Remove multiple active classes from all triggers
      accordions.forEach((btn) => btn.classList.remove("is-focused"));

      // Add multiple classes to the clicked one
      el.classList.add("is-focused");

      e.stopPropagation(); // Prevent outside click from firing
    });
  });

  // Listen for clicks outside
  document.addEventListener("click", () => {
    accordions.forEach((btn) => btn.classList.remove("is-focused"));
  });
})();

(() => {
  const gradiantTestClass = document.querySelectorAll(".textColorsGradiant");

  gradiantTestClass.forEach((el) => {
    el.addEventListener("click", (e) => {
      // Remove the active class from all other elements
      gradiantTestClass.forEach((btn) => {
        if (btn !== el) {
          btn.classList.remove("gradiantTextColors");
        }
      });

      // Toggle class on the clicked element
      el.classList.toggle("gradiantTextColors");
      e.stopPropagation();
    });
  });
})();
